import Vue from 'vue'
import i18n from './locales'
import App from './App.vue'
import router from './router'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import "../src/assets/style/index.scss"
import filter from "../core/filters/index"

Vue.config.productionTip = false

Vue.use(ElementUi)
filter(Vue)

window.i18n = i18n

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
